import { Checkbox, checkboxStates } from "@visiblethread/react-components";
import multiWorkspaces from "icons/multiWorkspaces.svg";
import PropTypes from "prop-types";
import React from "react";
import handleKeyboardClick from "utils/handleKeyboardClick";

const AddUserModalUser = ({
  username,
  checkedUsers,
  handleChange,
  hasMultipleWorkspaces,
}) => {
  const isChecked = checkedUsers.includes(username);
  const state = isChecked ? checkboxStates.checked : checkboxStates.empty;

  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    handleChange(username);
  };

  return (
    <div
      className="add__user__modal__users__container__user"
      data-testid="add-user-modal-user"
      onClick={onClick}
      onKeyDown={handleKeyboardClick(onClick)}
    >
      <span className="add__user__modal__users__container__user__name">
        {username}
      </span>
      {hasMultipleWorkspaces ? (
        <img src={multiWorkspaces} alt="multiWorkspaces" />
      ) : (
        <span style={{ flexBasis: "10%" }}>&nbsp;</span>
      )}
      <span className="add__user__modal__users__container__user__checkbox">
        <Checkbox
          state={state}
          handleChange={onClick}
          disabled={false}
          id={username}
          value="add_user_checkbox"
        />
      </span>
    </div>
  );
};

export default AddUserModalUser;

AddUserModalUser.propTypes = {
  username: PropTypes.string.isRequired,
  checkedUsers: PropTypes.arrayOf(PropTypes.string).isRequired,
  handleChange: PropTypes.func.isRequired,
  hasMultipleWorkspaces: PropTypes.bool.isRequired,
};
